import "./reset.css"

import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { App } from "./app/App"
import { env } from "./app/env"
import { createSentryClient } from "./app/integrations/sentry"

if (env.PAGE_BUILDER_SENTRY_ENABLED) createSentryClient()

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
